import { GeographicalLatLng } from "../type/Address.type";

export const AUTOCOMPLETE_THRESHOLD = 3;
export const API_SEARCH_LIMIT = 10;
export const GEOGRAPHICAL_PRIORITY_DEFAULT: GeographicalLatLng = { lat: 46.438, lng: 2.219 }; // France center (Centre-Val de Loire)
export const MAP_SEARCH_GEO_API_URL = "https://data.geopf.fr/geocodage/search/";
export const MAP_REVERSE_GEO_API_URL = "https://data.geopf.fr/geocodage/reverse/";
